import {NavLink} from "react-router-dom";
import React, {useContext} from "react";
import Badge from "react-bootstrap/Badge";
import {UserContext} from "../../context/UserContext";

const ClientMainMenu = () => {
  const {carts} = useContext(UserContext)

  return <>
    <li className="nav-item">
      <NavLink to="/my_dashboard" className="nav-link close-nav">Dashboard</NavLink>
    </li>
    <li className="nav-item">
      <NavLink to="/my_menus" className="nav-link close-nav">Meniuri</NavLink>
    </li>
    <li className="nav-item">
      <NavLink to="/shopping_list" className="nav-link close-nav">
        Cos cumparaturi {carts &&
        <Badge pill={true} bg="danger" className="align-text-bottom">
          {[...new Set(carts.map(a => a.ingredientId))].length}
        </Badge>}
      </NavLink>
    </li>
  </>
}
export default ClientMainMenu